import { render, staticRenderFns } from "./ElementTicker.vue?vue&type=template&id=396f1380&"
import script from "./ElementTicker.vue?vue&type=script&lang=js&"
export * from "./ElementTicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports